import { create } from 'zustand';
import { getExtensions } from '@/lib/extensions';

interface ExtensionsState {
  enabledExtensions: Set<string>;
  isLoaded: boolean;
  /**
   * The list could not be read (a role without access to it gets 403), so an
   * extension missing from it is unknown, not off. Screens that tell the
   * reader an extension is "not connected" check this first.
   */
  loadFailed: boolean;
  load: () => Promise<void>;
  isExtensionEnabled: (id: string) => boolean;
}

export const useExtensionsStore = create<ExtensionsState>((set, get) => ({
  enabledExtensions: new Set<string>(),
  isLoaded: false,
  loadFailed: false,

  load: async () => {
    try {
      const extensions = await getExtensions();
      const enabled = new Set(
        extensions.filter((ext) => ext.status === 'enabled').map((ext) => ext.id),
      );
      set({ enabledExtensions: enabled, isLoaded: true, loadFailed: false });
    } catch {
      set({ isLoaded: true, loadFailed: true });
    }
  },

  isExtensionEnabled: (id: string) => get().enabledExtensions.has(id),
}));
